import { useEffect } from "react";
import { toast } from "react-toastify";
import { useGetSuggestions } from "../hooks";
import { useAiImageStore } from "../store";

const WIDTHS = [50, 100, 80, 60];

export const AiImagePromptSuggestions = () => {
  const setPrompt = useAiImageStore((s) => s.setPrompt);
  const { handleGetSuggestions, isPending, isError, data, type } =
    useGetSuggestions();

  useEffect(() => {
    if (isPending) return;
    handleGetSuggestions();
  }, [type]);

  useEffect(() => {
    if (!isError) return;
    toast.error("Failed to get suggestions");
  }, [isError]);

  return (
    <div className="tw-flex tw-flex-col tw-gap-2">
      {isPending &&
        WIDTHS.map((width) => <Skeleton key={width} width={width} />)}
      {!isPending &&
        data?.map((suggestion) => (
          <button
            aria-label={suggestion}
            onClick={() => setPrompt(suggestion)}
            key={suggestion}
            type="button"
            className="tw-inline-flex tw-items-center tw-text-left tw-py-2 tw-font-sans tw-text-sm tw-w-fit tw-text-blue-800 tw-font-normal hover:tw-bg-blue-50 tw-transition-colors tw-duration-200 tw-justify-center tw-px-3 tw-rounded-[100px]"
          >
            {suggestion}
          </button>
        ))}
    </div>
  );
};

const Skeleton = ({ width = 100 }: { width?: number }) => {
  return (
    <div className="tw-inline-flex tw-items-center tw-justify-start tw-h-7 tw-px-3 tw-rounded-[100px]">
      <div
        className="tw-h-2 tw-w-full tw-bg-blue-50 tw-rounded-lg tw-animate-skeleton-loading"
        style={{ width: `${width}%` }}
      />
    </div>
  );
};
